import React from 'react';
import Title from '@/components/Title';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import LeadButton from '@/components/LeadButton';

const Index = () => {
  const { t } = useTranslation('whyWukong');
  return (
    <div className="mt-20 lg:mt-[140px] xl:mt-[180px]">
      <section className="container">
        <Title className="" innerHTML theme="colorful">
          {t('理由-教学团队-标题')}
        </Title>
      </section>
      <div className="mt-6 lg:pb-10 xl:pb-[50px]">
        <div className="flex flex-col items-center lg:container lg:flex-row lg:gap-[80px] xl:gap-[80px]">
          <div className="w-full bg-[url('/images/reasonsForChoosing/teachers/circle.svg')] bg-[length:200px_200px]	bg-right-bottom bg-no-repeat px-5 pb-[42px] lg:basis-[520px]  lg:bg-[length:220px_220px] lg:px-0 lg:pb-10 lg:pb-10 lg:pr-10 xl:basis-[660px] xl:bg-[length:400px_400px] xl:pb-[70px] xl:pr-15">
            <Image
              src="/images/reasonsForChoosing/teachers/teacher1.png"
              layout="responsive"
              width={0}
              height={0}
              className="h-auto w-full"
              alt={t('理由-老师1-标题')}
            />
          </div>
          <div className="-mt-[18px] w-full px-5 lg:basis-[424px] lg:px-0 xl:basis-[660px] xl:pb-14">
            <h3 className="mb-3 text-xl font-semibold leading-normal text-wk-words-1 lg:text-[28px] xl:text-[34px]">
              {t('理由-老师1-标题')}
            </h3>
            <p className="text-base leading-6 text-wk-words-2 lg:text-[20px] lg:leading-8 xl:text-[28px] xl:leading-[46px]">
              {t('理由-老师1-介绍')}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-15 lg:mt-0 xl:pb-[50px]">
        <div className="flex flex-col items-center lg:container lg:flex-row lg:gap-[80px] xl:gap-[80px]">
          <div className="w-full bg-[url('/images/reasonsForChoosing/teachers/circle.svg')] bg-[length:200px_200px] bg-right-bottom bg-no-repeat px-5 pb-[42px] lg:order-last lg:basis-[520px] lg:bg-[length:220px_220px]  lg:bg-left-bottom lg:px-0 lg:pb-10 lg:pb-10 lg:pl-10 xl:basis-[660px] xl:bg-[length:400px_400px] xl:pb-[70px] xl:pl-15">
            <Image
              src="/images/reasonsForChoosing/teachers/teacher2.png"
              layout="responsive"
              width={0}
              height={0}
              className="h-auto w-full rounded-3xl"
              alt={t('理由-老师2-标题')}
            />
          </div>
          <div className="-mt-[18px] w-full px-5 lg:basis-[424px] lg:px-0 xl:basis-[660px] xl:pb-14">
            <h3 className="mb-3 text-xl font-semibold leading-normal text-wk-words-1 lg:text-[28px] xl:text-[34px]">
              {t('理由-老师2-标题')}
            </h3>
            <p className="text-base leading-6 text-wk-words-2 lg:text-[20px] lg:leading-8 xl:text-[28px] xl:leading-[46px]">
              {t('理由-老师2-介绍')}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-6 text-center lg:mt-2 xl:mt-2">
        <LeadButton
          theme="colorfulBorder"
          size="xl"
          traceName="O_WhyWuKong_TeacherAdvantage_CTAClick"
          traceGa4Name="new_entry_How_TeacherAdvantageCTA"
        >
          {t('理由-立即体验')}
        </LeadButton>
      </div>
    </div>
  );
};

export default Index;
